import { useRoutes } from "react-router-dom"
import { lazy, Suspense } from "react"
import { PageLoader } from "src/shared/components"
import { Root } from "src/shared/components"
import appRoutes from "./app-routes/app-routes"
import posRoutes from "./pos-routes/pos-routes"
import Barcodes from "src/modules/invoices/pages/barcodes"
import Invite from "src/modules/auth/pages/invite"
import ResetPassword from "src/modules/auth/pages/reset-password"
import ForgotPassword from "src/modules/auth/pages/forgot-password"
import TransferListInvoice from "src/modules/invoices/pages/transfer-list-invoice"
import DemoXoutReportReceipt from "src/modules/invoices/thermal/xout-report-receipt/demo"
import OrderReceiptTemplate1Example from "src/modules/POS/receipt/order-receipt-template-1-example"
import OrderReceiptTemplate2Example from "src/modules/POS/receipt/order-receipt-template-2-example"
import DemoReturnReceipt from "src/modules/invoices/thermal/return-receipt/demo"
import OrderDetailReceiptDemo from "src/modules/invoices/thermal/order-detailed-receipt/demo"

// Lazy load all components
const Login = lazy(() => import("src/modules/auth/pages/Login"))
const NotFound = lazy(() => import("src/modules/error/pages/NotFound404"))
const Navigateto404 = lazy(() => import("src/modules/error/pages/Navigateto404"))
const TransferNoteInvoice = lazy(() => import("src/modules/invoices/pages/transfer-note"))
const DemandNoteDetailsInvoice = lazy(() => import("src/modules/invoices/pages/demand-note-details"))
const PoInvoice = lazy(() => import("src/modules/invoices/pages/po-invoice"))
const GrnInvoice = lazy(() => import("src/modules/invoices/pages/grn-invoice"))
const StockReturnInvoice = lazy(() => import("src/modules/invoices/pages/stock-return-invoice"))
const ChildrenList = lazy(() => import("src/modules/invoices/pages/children-list"))
const ReceiveListInvoice = lazy(() => import("src/modules/invoices/pages/receive-list-invoice"))

// Wrapper component for lazy loading
const LazyLoad = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<PageLoader isLoading={true} />}>{children}</Suspense>
)

const Routes = () => {
  const PublicRoutes = [
    {
      path: "404",
      element: (
        <LazyLoad>
          <NotFound />
        </LazyLoad>
      )
    },
    {
      path: "invoice",
      element: <Root />,
      children: [
        {
          path: "po-invoice/:id",
          element: (
            <LazyLoad>
              <PoInvoice />
            </LazyLoad>
          )
        },
        {
          path: "grn-invoice/:id",
          element: (
            <LazyLoad>
              <GrnInvoice />
            </LazyLoad>
          )
        },
        {
          path: "stock-return-invoice/:id",
          element: (
            <LazyLoad>
              <StockReturnInvoice />
            </LazyLoad>
          )
        },
        {
          path: "receive-list/:id",
          element: (
            <LazyLoad>
              <ReceiveListInvoice />
            </LazyLoad>
          )
        },
        {
          path: "transfer-list/:id",
          element: (
            <LazyLoad>
              <TransferListInvoice />
            </LazyLoad>
          )
        },
        {
          path: "child-list/:id",
          element: (
            <LazyLoad>
              <ChildrenList />
            </LazyLoad>
          )
        },
        {
          path: "transfer-note/:id",
          element: (
            <LazyLoad>
              <TransferNoteInvoice />
            </LazyLoad>
          )
        },
        {
          path: "demand-note/:id",
          element: (
            <LazyLoad>
              <DemandNoteDetailsInvoice />
            </LazyLoad>
          )
        },
        {
          path: "barcodes/:id",
          element: (
            <LazyLoad>
              <Barcodes />
            </LazyLoad>
          )
        }
      ]
    },
    appRoutes,
    posRoutes,
    {
      path: "/",
      element: (
        <LazyLoad>
          <Login />
        </LazyLoad>
      )
    },
    {
      path: "/invite/accept",
      element: (
        <LazyLoad>
          <Invite />
        </LazyLoad>
      )
    },
    {
      path: "/password-reset/new",
      element: (
        <LazyLoad>
          <ForgotPassword />
        </LazyLoad>
      )
    },
    {
      path: "/password-reset/change",
      element: (
        <LazyLoad>
          <ResetPassword />
        </LazyLoad>
      )
    },
    {
      path: "*",
      element: (
        <LazyLoad>
          <Navigateto404 />
        </LazyLoad>
      )
    },
    {
      path: "order-receipt/template1",
      element: (
        <LazyLoad>
          <OrderReceiptTemplate1Example />
        </LazyLoad>
      )
    },
    {
      path: "order-receipt/template2",
      element: (
        <LazyLoad>
          <OrderReceiptTemplate2Example />
        </LazyLoad>
      )
    },
    {
      path: "demo-xout-slip",
      element: (
        <LazyLoad>
          <DemoXoutReportReceipt />
        </LazyLoad>
      )
    },
    {
      path: "demo-return-receipt",
      element: (
        <LazyLoad>
          <DemoReturnReceipt />
        </LazyLoad>
      )
    },
    {
      path: "demo-order-detailed-receipt",
      element: (
        <LazyLoad>
          <OrderDetailReceiptDemo />
        </LazyLoad>
      )
    }
  ]

  return useRoutes([...PublicRoutes])
}

export default Routes
